// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_table__uB1wj {
  width: max-content;
  min-width: 100%;
  border-collapse: separate; /* permite espaçamento entre células */
  border-spacing: 2px 0; /* separa horizontalmente (headers/células) com distância mínima */
}

.styles_table__uB1wj th,
.styles_table__uB1wj td {
  border: 1px solid transparent; /* evita colar visual entre células */
  max-width: none;
  padding: 0.1rem 0.5rem;
  text-align: center;
  white-space: nowrap;
  line-height: 1.2;
  font-size: 0.875rem;
}

/* Estilo específico para cabeçalhos: restaura o fundo e arredondamento */
.styles_table__uB1wj th {
  background-color: #f5f5f5;
  border-radius: 6px;
  color: #18316e; /* restaura cor azul dos títulos */
}

/* Coluna fixa à direita (Composição Projeto) */
.styles_stickyRightHeader__bt\\+Ui {
  position: sticky;
  right: 0;
  z-index: 3; /* acima das células */
  background-color: #f5f5f5; /* garantir fundo sólido durante scroll */
}

.styles_stickyRight__eUcZ- {
  position: sticky;
  right: 0;
  z-index: 2;
  background: #fff; /* fundo da célula para não "vazar" conteúdo por trás */
}

.styles_tableBody__Wj2mi {
  border-radius: 6px;
}

.styles_btnContainer__EI-vL {
  display: flex;
  justify-content: center;
}

.styles_uniqueBtn__ZJOT9 {
  align-items: center;
  background: #18316e;
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0.3rem 1.5rem;
}

.styles_btnAction__AG2bG {
  align-items: center;
  background-color: #18316e;
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  display: flex;
  padding: 0.3rem 1.5rem;
}

.styles_btns__Q2qyG {
  display: flex;
  justify-content: space-around;
  gap: 10px;
}

.styles_btn__NPhGr {
  align-items: center;
  background-color: white;
  border: none;
  border-radius: 4px;
  color: #18316e;
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  justify-content: center;
  padding: 10px 20px;
  width: 100%;
}

.styles_btn__NPhGr span {
  margin-right: 0.5rem;
}

.styles_btn__NPhGr:hover {
  background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableCardResumo/TableViewResumo/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE,sCAAsC;EACjE,qBAAqB,EAAE,kEAAkE;AAC3F;;AAEA;;EAEE,6BAA6B,EAAE,qCAAqC;EACpE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc,EAAE,kCAAkC;AACpD;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU,EAAE,sBAAsB;EAClC,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: separate; /* permite espaçamento entre células */\n  border-spacing: 2px 0; /* separa horizontalmente (headers/células) com distância mínima */\n}\n\n.table th,\n.table td {\n  border: 1px solid transparent; /* evita colar visual entre células */\n  max-width: none;\n  padding: 0.1rem 0.5rem;\n  text-align: center;\n  white-space: nowrap;\n  line-height: 1.2;\n  font-size: 0.875rem;\n}\n\n/* Estilo específico para cabeçalhos: restaura o fundo e arredondamento */\n.table th {\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  color: #18316e; /* restaura cor azul dos títulos */\n}\n\n/* Coluna fixa à direita (Composição Projeto) */\n.stickyRightHeader {\n  position: sticky;\n  right: 0;\n  z-index: 3; /* acima das células */\n  background-color: #f5f5f5; /* garantir fundo sólido durante scroll */\n}\n\n.stickyRight {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  background: #fff; /* fundo da célula para não \"vazar\" conteúdo por trás */\n}\n\n.tableBody {\n  border-radius: 6px;\n}\n\n.btnContainer {\n  display: flex;\n  justify-content: center;\n}\n\n.uniqueBtn {\n  align-items: center;\n  background: #18316e;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  padding: 0.3rem 1.5rem;\n}\n\n.btnAction {\n  align-items: center;\n  background-color: #18316e;\n  border: none;\n  border-radius: 10px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  padding: 0.3rem 1.5rem;\n}\n\n.btns {\n  display: flex;\n  justify-content: space-around;\n  gap: 10px;\n}\n\n.btn {\n  align-items: center;\n  background-color: white;\n  border: none;\n  border-radius: 4px;\n  color: #18316e;\n  cursor: pointer;\n  display: flex;\n  font-size: 1rem;\n  justify-content: center;\n  padding: 10px 20px;\n  width: 100%;\n}\n\n.btn span {\n  margin-right: 0.5rem;\n}\n\n.btn:hover {\n  background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `styles_table__uB1wj`,
	"stickyRightHeader": `styles_stickyRightHeader__bt+Ui`,
	"stickyRight": `styles_stickyRight__eUcZ-`,
	"tableBody": `styles_tableBody__Wj2mi`,
	"btnContainer": `styles_btnContainer__EI-vL`,
	"uniqueBtn": `styles_uniqueBtn__ZJOT9`,
	"btnAction": `styles_btnAction__AG2bG`,
	"btns": `styles_btns__Q2qyG`,
	"btn": `styles_btn__NPhGr`
};
export default ___CSS_LOADER_EXPORT___;
